export const UWM_INIT_MARKET_LOCALE = 'UWM_INIT_MARKET_LOCALE';
export const UWM_MODULE_LOADED = 'UWM_MODULE_LOADED';
export const UWM_MODULE_INITIALIZATION_ERROR = 'UWM_MODULE_INITIALIZATION_ERROR';
export const UWM_MODULE_BACK_BUTTON_CLICK = 'UWM_MODULE_BACK_BUTTON_CLICK';
export const UWM_MODULE_DATA_RECEIVED_SUCCESS = 'UWM_MODULE_DATA_RECEIVED_SUCCESS';
export const UWM_MODULE_MEDIA_CACHED = 'UWM_MODULE_MEDIA_CACHED';
export const UWM_AMPLITUDE_TRACKING = 'UWM_AMPLITUDE_TRACKING';
export const UWM_MODULE_NAVIGATE_TO_WIFI_GUIDE = 'UWM_MODULE_NAVIGATE_TO_WIFI_GUIDE';
